<template>
<span class="banner-subtext">We are a resale marketplace. Ticket prices may exceed face value. This site is not a primary ticket seller or box office.</span>
</template>

<script>
export default {
  name: 'BannerSubText'
}
</script>
